import IconButton from '@/global/components/Button/IconButton'
import { cn } from '@/lib/utils'
import { minutesToHours as hr, hoursToMinutes as min } from '@acme/common'
import { Divider, Typography } from '@mui/material'
import { InfoIcon } from 'lucide-react'
import React from 'react'
import Menu from './MenuV2'

interface IPropsSaldo {
    title: React.ReactNode
    extras?: string
    faltas?: string
    porcentagens?: { [key: string]: string }
    tipoFaltas?: { [key: string]: string }
    sx?: React.CSSProperties
    underline?: boolean
}

export default function SaldoBox({
    extras = '00:00',
    faltas = '00:00',
    porcentagens = {},
    tipoFaltas = {},
    title,
    sx,
    underline,
}: IPropsSaldo) {
    return (
        <div
            style={sx}
            className="flex gap-1 items-center border rounded-sm py-0.5 px-2"
        >
            <span
                className={cn(
                    'text-nowrap text-sm font-semibold',
                    underline ? 'underline' : 'decoration-inherit',
                )}
            >
                {title}
            </span>
            <Divider orientation="vertical" flexItem />
            <div>
                <div className="text-nowrap text-sm font-normal flex gap-1">
                    {`Extras: ${extras}`}
                    <Menu.Root position="top-center" arrow>
                        {!!Object.keys(porcentagens).length && (
                            <Menu.Trigger>
                                <IconButton
                                    size="small"
                                    className="size-fit p-0 inline-flex items-center -mt-0.5"
                                >
                                    <InfoIcon className="size-4" />
                                </IconButton>
                            </Menu.Trigger>
                        )}
                        <Menu.List
                            slotProps={{
                                paper: {
                                    sx: {
                                        marginTop: -1,
                                        marginLeft: -0.5,
                                    },
                                },
                            }}
                        >
                            {Object.entries(porcentagens).map(
                                ([key, valor]) => (
                                    <Menu.Item
                                        key={key}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            gap: '1rem',
                                            cursor: 'default',
                                        }}
                                    >
                                        <Typography noWrap variant="body2">
                                            Horas Extras {key}
                                            %:
                                        </Typography>
                                        <Typography noWrap variant="body2">
                                            {hr(min(valor))}
                                        </Typography>
                                    </Menu.Item>
                                ),
                            )}
                        </Menu.List>
                    </Menu.Root>
                </div>
                <div className="text-nowrap text-sm font-normal flex gap-1">
                    {`Faltas: ${faltas}`}
                    <Menu.Root position="top-center" arrow>
                        {!!Object.values(tipoFaltas).filter(Boolean).length && (
                            <Menu.Trigger>
                                <IconButton
                                    size="small"
                                    className="size-fit p-0 inline-flex items-center -mt-0.5"
                                >
                                    <InfoIcon className="size-4" />
                                </IconButton>
                            </Menu.Trigger>
                        )}
                        <Menu.List
                            slotProps={{
                                paper: {
                                    sx: {
                                        marginTop: -1,
                                        marginLeft: -0.5,
                                    },
                                },
                            }}
                        >
                            {Object.entries(tipoFaltas).map(([key, valor]) => (
                                <Menu.Item
                                    key={key}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: '1rem',
                                        cursor: 'default',
                                    }}
                                >
                                    <Typography noWrap variant="body2">
                                        Faltas {key}:
                                    </Typography>
                                    <Typography noWrap variant="body2">
                                        {valor}
                                    </Typography>
                                </Menu.Item>
                            ))}
                        </Menu.List>
                    </Menu.Root>
                </div>
            </div>
        </div>
    )
}
